import get from "lodash.get";

import MapApi from "services/map/api";
import CustomAnalysisApi from "./api";
import CustomAnalysisActionTypes from "./types";
import CustomAnalysisUtils from "./utils";

class CustomAnalysisActioner {
  static setAttendance(data) {
    return {
      type: CustomAnalysisActionTypes.SET_ATTENDANCE,
      data,
    };
  }

  static setAttendanceStats(data) {
    return {
      type: CustomAnalysisActionTypes.SET_ATTENDANCE_STATS,
      data,
    };
  }

  static setAttendanceFilters(data) {
    return {
      type: CustomAnalysisActionTypes.SET_ATTENDANCE_FILTERS,
      data,
    };
  }

  static setAttendancePeakFilters(data) {
    return {
      type: CustomAnalysisActionTypes.SET_ATTENDANCE_PEAK_FILTERS,
      data,
    };
  }

  static setHourlyAttendanceFilters(data) {
    return {
      type: CustomAnalysisActionTypes.SET_HOURLY_ATTENDANCE_FILTERS,
      data,
    };
  }

  static setDowAttendance(data) {
    return {
      type: CustomAnalysisActionTypes.SET_DOW_ATTENDANCE,
      data,
    };
  }

  static setHourlyAttendance(data) {
    return {
      type: CustomAnalysisActionTypes.SET_HOURLY_ATTENDANCE,
      data,
    };
  }

  static setAttendancePeak(data) {
    return {
      type: CustomAnalysisActionTypes.SET_ATTENDANCE_PEAK,
      data,
    };
  }

  static setPressure(data) {
    return {
      type: CustomAnalysisActionTypes.SET_PRESSURE,
      data,
    };
  }

  static setDowPressure(data) {
    return {
      type: CustomAnalysisActionTypes.SET_DOW_PRESSURE,
      data,
    };
  }

  static setLoading(statName) {
    return {
      type: CustomAnalysisActionTypes.SET_LOADING,
      statName,
    };
  }

  static setAutoRefresh(autoRefresh) {
    return {
      type: CustomAnalysisActionTypes.SET_AUTO_REFRESH,
      autoRefresh,
    };
  }

  static setInitialized(value) {
    return {
      type: CustomAnalysisActionTypes.SET_INITIALIZED,
      value,
    };
  }

  static setFilters = (data) => {
    return {
      type: CustomAnalysisActionTypes.SET_FILTERS,
      data,
    };
  };

  static setFilter = (key, value) => {
    return {
      type: CustomAnalysisActionTypes.SET_FILTER,
      key,
      value,
    };
  };

  static retrieveAttendanceByDayOfWeek = (type, data) => {
    return (dispatch, getState) => {
      const CustomAnalysisState = getState().CustomAnalysis;
      const filters = get(CustomAnalysisState, "dowAttendance.filters");

      return dispatch(
        CustomAnalysisActioner.retrieveAttendanceByFilters(
          data,
          filters,
          "dowAttendance"
        )
      ).then((data) => {
        dispatch(CustomAnalysisActioner.setDowAttendance({ [type]: data }));
      });
    };
  };

  static retrieveHourlyAttendanceByDayOfWeek = (type, data) => {
    return (dispatch, getState) => {
      const CustomAnalysisState = getState().CustomAnalysis;
      const filters = get(CustomAnalysisState, "hourlyAttendance.filters");

      return dispatch(
        CustomAnalysisActioner.retrieveHourlyAttendanceByFilters(
          data,
          filters,
          "hourlyAttendance"
        )
      ).then((data) => {
        dispatch(CustomAnalysisActioner.setHourlyAttendance({ [type]: data }));
      });
    };
  };

  static retrieveAttendanceStatsByDayOfWeek = (type, data) => {
    return (dispatch, getState) => {
      const CustomAnalysisState = getState().CustomAnalysis;
      const filters = get(CustomAnalysisState, "attendanceStats.filters");

      return dispatch(
        CustomAnalysisActioner.retrieveAttendanceStatsByFilters(
          data,
          filters,
          "attendanceStats"
        )
      ).then((data) => {
        dispatch(CustomAnalysisActioner.setAttendanceStats({ [type]: data }));
      });
    };
  };

  static retrievePressureByDayOfWeek = (type, data) => {
    return (dispatch, getState) => {
      const CustomAnalysisState = getState().CustomAnalysis;
      const filters = get(CustomAnalysisState, "dowPressure.filters");

      return dispatch(
        CustomAnalysisActioner.retrievePressureByFilters(data, filters)
      ).then((data) => {
        dispatch(CustomAnalysisActioner.setDowPressure({ [type]: data }));
      });
    };
  };

  static retrieveAttendanceGraph = (type, data) => {
    return (dispatch, getState) => {
      const CustomAnalysisState = getState().CustomAnalysis;
      const filters = get(CustomAnalysisState, "attendance.filters");

      return dispatch(
        CustomAnalysisActioner.retrieveAttendanceByFilters(
          data,
          filters,
          "attendance"
        )
      ).then((data) => {
        dispatch(CustomAnalysisActioner.setAttendance({ [type]: data }));
      });
    };
  };

  static retrieveAttendancePeakData = (type, data) => {
    return (dispatch, getState) => {
      const CustomAnalysisState = getState().CustomAnalysis;
      const filters = get(CustomAnalysisState, "attendancePeak.filters");

      return dispatch(
        CustomAnalysisActioner.retrieveAttendancePeakByFilters(data, filters)
      ).then((data) => {
        dispatch(CustomAnalysisActioner.setAttendancePeak({ [type]: data }));
      });
    };
  };

  static retrieveAllStats = () => {
    return (dispatch, getState) => {
      const CustomAnalysisState = getState().CustomAnalysis;
      const withComparison = get(CustomAnalysisState, "filters.withComparison");

      dispatch(CustomAnalysisActioner.setInitialized(false));

      const data = CustomAnalysisUtils.getBodyFromStateAndType(
        getState(),
        "analysis"
      );
      let promises = [
        dispatch(
          CustomAnalysisActioner.retrieveAttendanceByDayOfWeek("analysis", data)
        ),
        dispatch(
          CustomAnalysisActioner.retrievePressureByDayOfWeek("analysis", data)
        ),
        dispatch(
          CustomAnalysisActioner.retrieveAttendanceGraph("analysis", data)
        ),
        dispatch(
          CustomAnalysisActioner.retrieveAttendancePeakData("analysis", data)
        ),
        dispatch(
          CustomAnalysisActioner.retrieveHourlyAttendanceByDayOfWeek(
            "analysis",
            data
          )
        ),
        dispatch(
          CustomAnalysisActioner.retrieveAttendanceStatsByDayOfWeek(
            "analysis",
            data
          )
        ),
      ];

      if (withComparison) {
        const comparedData = CustomAnalysisUtils.getBodyFromStateAndType(
          getState(),
          "compared"
        );
        promises = [
          ...promises,
          dispatch(
            CustomAnalysisActioner.retrieveAttendanceByDayOfWeek(
              "compared",
              comparedData
            )
          ),
          dispatch(
            CustomAnalysisActioner.retrievePressureByDayOfWeek(
              "compared",
              comparedData
            )
          ),
          dispatch(
            CustomAnalysisActioner.retrieveAttendanceGraph(
              "compared",
              comparedData
            )
          ),
          dispatch(
            CustomAnalysisActioner.retrieveAttendancePeakData(
              "compared",
              comparedData
            )
          ),
          dispatch(
            CustomAnalysisActioner.retrieveHourlyAttendanceByDayOfWeek(
              "compared",
              comparedData
            )
          ),
          dispatch(
            CustomAnalysisActioner.retrieveAttendanceStatsByDayOfWeek(
              "compared",
              comparedData
            )
          ),
        ];
      }

      return Promise.all(promises).then((res) => {
        dispatch(CustomAnalysisActioner.setInitialized(true));
        return res;
      });
    };
  };

  static retrieveAttendanceByFilters(data, filters, graph) {
    return (dispatch, getState) => {
      const CustomAnalysisState = getState().CustomAnalysis;

      if (!get(CustomAnalysisState, "autoRefresh", false)) {
        dispatch(CustomAnalysisActioner.setLoading(graph));
      }

      return CustomAnalysisApi.getAttendance(data, filters).catch((error) => {
        return Promise.reject(error);
      });
    };
  }

  static retrieveAttendanceStatsByFilters(data, filters, graph) {
    return (dispatch, getState) => {
      const CustomAnalysisState = getState().CustomAnalysis;

      if (!get(CustomAnalysisState, "autoRefresh", false)) {
        dispatch(CustomAnalysisActioner.setLoading(graph));
      }

      return CustomAnalysisApi.getAttendanceStats(data, filters).catch(
        (error) => {
          return Promise.reject(error);
        }
      );
    };
  }

  static retrieveHourlyAttendanceByFilters(data, filters, graph) {
    return (dispatch, getState) => {
      const CustomAnalysisState = getState().CustomAnalysis;

      if (!get(CustomAnalysisState, "autoRefresh", false)) {
        dispatch(CustomAnalysisActioner.setLoading(graph));
      }

      return CustomAnalysisApi.getHourlyAttendance(data, filters).catch(
        (error) => {
          return Promise.reject(error);
        }
      );
    };
  }

  static retrieveAttendancePeakByFilters(data, filters) {
    return (dispatch, getState) => {
      const CustomAnalysisState = getState().CustomAnalysis;

      if (!get(CustomAnalysisState, "autoRefresh", false)) {
        dispatch(CustomAnalysisActioner.setLoading("attendancePeak"));
      }
      return CustomAnalysisApi.getAttendancePeak(data, filters).catch(
        (error) => {
          return Promise.reject(error);
        }
      );
    };
  }

  static retrievePressureByFilters(data, filters) {
    return (dispatch, getState) => {
      const CustomAnalysisState = getState().CustomAnalysis;

      if (!get(CustomAnalysisState, "autoRefresh", false)) {
        dispatch(CustomAnalysisActioner.setLoading("pressure"));
      }

      return CustomAnalysisApi.getPressure(data, filters).catch((error) => {
        return Promise.reject(error);
      });
    };
  }

  static retrieveLayersInfos() {
    return (dispatch, getState) => {
      const contractId = getState().Contract.contract.id;
      const LayersInfosPromises = [
        MapApi.getAreasInfos({
          contract_id: contractId,
          types: ["PARK", "PARKANDFLOW", "PEDESTRIAN", "PEDESTRIANANDFLOW"],
        }),
      ];

      return Promise.all(LayersInfosPromises).then(([areasInfos]) => {
        const mapCustomAnalysisParkingConfig = get(
          getState(),
          "Map.config.parking",
          {}
        );
        const mapCustomAnalysisPedestrianConfig = get(
          getState(),
          "Map.config.pedestrian",
          {}
        );
        const mapCustomAnalysisConfig = {
          areas: [
            ...(mapCustomAnalysisParkingConfig?.areas || []),
            ...(mapCustomAnalysisPedestrianConfig?.areas || []),
          ],
        };
        const currentSelectedAreas = get(
          getState(),
          "CustomAnalysis.filters.selectedAreas",
          []
        );

        const allowedGroup =
          get(
            getState(),
            "CustomAnalysis.filters.analysisAreaGroups.selected",
            undefined
          ) ??
          get(
            getState(),
            "CustomAnalysis.filters.analysisAreaGroups.default",
            undefined
          );

        const groups = get(
          getState(),
          "CustomAnalysis.filters.analysisAreaGroups.groups",
          []
        );
        const allowedTypes = groups.find(
          (group) => group.name === allowedGroup
        )?.analysis_area_types;
        const formattedInfos = CustomAnalysisUtils.formatLayersInfosFromApi(
          { ...areasInfos },
          mapCustomAnalysisConfig,
          currentSelectedAreas,
          allowedTypes
        );

        dispatch(
          CustomAnalysisActioner.setFilter(
            "areas",
            get(formattedInfos, "areas", []).sort((a, b) => {
              if (a.long_name < b.long_name) {
                return -1;
              }
              if (a.long_name > b.long_name) {
                return 1;
              }
              return 0;
            })
          )
        );
        dispatch(
          CustomAnalysisActioner.setFilter(
            "selectedAreas",
            get(formattedInfos, "selectedAreas", [])
          )
        );
        return formattedInfos;
      });
    };
  }
}

export default CustomAnalysisActioner;
